<template>
  <ul class="nav justify-content-between align-items-center border px-3 border-2 sticky-top bg-white">
    <li v-if="!hideLeft" class="navbar-item justify-content-start">
      <NavbarLeftItem />
    </li>
    <li v-if="!hideCenter" class="navbar-item justify-content-center">
      <NavbarCenterItem :title="title" />
    </li>
    <li v-if="!hideRight" class="navbar-item justify-content-end">
      <NavbarRightItem :session="session" />
    </li>
  </ul>
</template>

<script setup lang="ts">
import NavbarCenterItem from './NavbarCenterItem.vue'
import NavbarLeftItem from './NavbarLeftItem.vue'
import NavbarRightItem from './NavbarRightItem.vue'
import { useSessionStore } from '@/store/useSessionStore';
import { storeToRefs } from 'pinia';
const sessionStore = useSessionStore()
const { session } = storeToRefs(sessionStore)

defineProps<{
  title?: string
  hideRight?: boolean
  hideCenter?: boolean
  hideLeft?: boolean
}>()
</script>

<style scoped>
.nav {
  height: 55px;
}

.navbar-item {
  display: flex;
  flex: 1
}
</style>